module.exports = __webpack_public_path__ + "img/entia-portafolio-infraestructura-carrusel-2.07577456.webp";